<div class="forgot-screen">

    <app-vormen></app-vormen>

    <!-- Card -->
    <div class="forgot-card">

        <div class="brand-logo">
            <img src="assets/img/logo.svg" alt="OpStoom" class="logo-img" />
        </div>

        <h4 class="title">{{ "forgotPassword.title" | translate }}</h4>
        <p class="subtitle">{{ "forgotPassword.instruction" | translate }}</p>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <input
                    type="text"
                    formControlName="username"
                    placeholder="{{ 'forgotPassword.username' | translate }}"
                    class="form-control"
                    [class.input-error]="form.get('username')?.invalid && form.get('username')?.touched"
                />
                <p class="validation-error"
                   *ngIf="form.get('username')?.touched && form.get('username')?.hasError('minlength')">
                    {{ 'forgotPassword.usernameMinLength' | translate }}
                </p>
                <p class="validation-error"
                   *ngIf="form.get('username')?.touched && form.get('username')?.hasError('required')">
                    {{ 'forgotPassword.usernameRequired' | translate }}
                </p>
            </div>

            <messages
                class="general-error"
                [form]="form"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="FALSE"
                [showFieldKeys]="FALSE"
            ></messages>

            <div class="button-container">
                <action-button
                    class="btn-send"
                    (actionEvent)="onSubmit($event)"
                    label="{{ 'forgotPassword.sendLink' | translate }}">
                </action-button>
            </div>

            <a class="back-link" (click)="logout()">
                <span class="material-icons">arrow_back</span>
                {{ "forgotPassword.back" | translate }}
            </a>
        </form>
    </div>
</div>
